import { all, takeLatest, put } from 'redux-saga/effects';
import { matchesType } from '../../sagas';
import { App as actions } from '../../../Actions';
import { consentIsAccepted } from '../../../Api/businessConsentsClient';
import { getBusinessUnit } from '../../../Api/businessUnitClient';

function* fetchBusinessUnitId(action: ReturnType<typeof actions.setGlobalState>) {
    const { integrationKey } = action.payload.state;
    if (!integrationKey) {
        return;
    }
    const consentResponse = yield consentIsAccepted(integrationKey);
    if (consentResponse && consentResponse.consentIsAccepted) {
        yield put(
            actions.setBusinessUnitId(consentResponse.businessUnitId)
        );
    }
}

function* fetchBusinessUnit(action: ReturnType<typeof actions.setGlobalState>) {
    const businessUnitId = action.payload.failedBusinessUnitId;
    if (!businessUnitId) {
        yield put(actions.setAccessErrorSuccess(null));
        return;
    }

    try {
        const businessUnit = yield getBusinessUnit(businessUnitId);
        yield put(actions.setAccessErrorSuccess(businessUnit));
    } catch (e) {
        yield put(actions.setAccessErrorSuccess({}));
    }
}

export function* app() {
    yield all([
        takeLatest(matchesType(actions.setGlobalState), fetchBusinessUnitId),
        takeLatest(matchesType(actions.setAccessError), fetchBusinessUnit),
    ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/App/index.ts